import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

import { IVendorCompanyMast } from "../../models/VendorCompanyMast";

import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { JVDropdown } from "../../shared/JVDropdown";
import { ICityMastDropdown, IPartnerCategoryDropdown, IStateMastDropdown } from "../../models/IDropdown";
import { IVendorTypeMastDropdown } from "../../models/IDropdown";
import { JVDropdownInput } from "../../shared/JVDropdownInput";
import { EmptyVendorCompany } from "./EmptyVendorCompany";
import { JVInputMask } from "../../shared/JVInputMask";
import { JVCheckbox } from "../../shared/JVCheckbox";
import { ILogin } from "../../models/Login";


const schema = yup.object({
    vendor_Company_Name: yup.string().required("Company Name is required*").min(3),
    vendor_Company_FidNo: yup.string(),
    vendor_Company_Phone: yup.string().required("Phone No is required*"),
    vendor_Company_Phone1: yup.string(),
    vendor_Company_FaxNo: yup.string(),
    vendor_Type: yup.number().min(1, "Vendor Type is required*").required("Vendor Type is required*"),
    street_Address: yup.string().required("Street Address is required*"),
    state: yup.object().shape({
        state_ID: yup.number().min(1, "State is required*").required("State is required*"),
        state_Name: yup.string().required()
    }),
    city: yup.object().shape({
        city_ID: yup.number().min(1, "City is required*").required("City is required*"),
        city_Name: yup.string().required()
    }),
    major_Technology: yup.string(),
    website_URL: yup.string().required().url()
});

interface Iprops {
    singleData: IVendorCompanyMast,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

export const Form = (props: Iprops) => {
    const [loading, setLoading] = useState(false);
    const [states, setStates] = useState<Array<IStateMastDropdown>>();
    const [cities, setCities] = useState<Array<ICityMastDropdown>>();
    const [vendorTypes, setVendorTypes] = useState<Array<IVendorTypeMastDropdown>>();
    const [isDisablePV, setIsDisablePV] = useState(false);
    const [partnerCategory, setPartnerCategory] = useState<Array<IPartnerCategoryDropdown>>();

    const { control, handleSubmit, formState: { errors }, reset, watch } = useForm<IVendorCompanyMast>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach((role: { role_ID: number; }) => {
        _roles.push(role.role_ID);
    });

    useEffect(() => {
        reset(props.singleData);
        if (props.singleData.disable_Share_PV) {
            setIsDisablePV(true);
        }
    }, [props.singleData])

    const loadCities = async (filter: string | null) => {
        if (control._formValues.state?.state_ID) {
            const response = await Fetch("Dropdown/cities", "GET", null, `filter=${filter}&state_id=${control._formValues.state.state_ID}`, null);
            if (response) {
                const data: Array<ICityMastDropdown> = await response.json();
                setCities(data);
            }
        } else {
            props.toast.current.show({ severity: 'error', detail: "Select the State First.", life: 3000 });
        }
    }
    const completeMethodCities = (event: { query: string }) => {
        loadCities(event.query);
    }

    const loadStates = async (filter: string | null) => {
        const response = await Fetch("Dropdown/states", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IStateMastDropdown> = await response.json();
            setStates(data);
        }
    }
    const completeMethodStates = (event: { query: string }) => {
        loadStates(event.query);
    }

    const loadVendorTypes = async () => {
        const response = await Fetch("Dropdown/vendorTypes", "GET", null, null, null);
        if (response) {
            const data: Array<IVendorTypeMastDropdown> = await response.json();
            setVendorTypes(data);
        }
    }

    const loadcategory = async () => {
        const response = await Fetch("Dropdown/pV_Partner_Category", "GET", null, null, null);
        if (response) {
            const data: Array<IPartnerCategoryDropdown> = await response.json();
              const emptyData = {
                id: 0,
                status_Name: "-- SELECT --",
            };
            data.unshift(emptyData);
            setPartnerCategory(data);
        }
    }

    useEffect(() => {
        loadVendorTypes();
        loadcategory();
    }, []);

    const saveToDB = async (body: IVendorCompanyMast) => {
        setLoading(true);
        const method = props.singleData.vendor_Company_ID ? "PUT" : "POST";
        const message = props.singleData.vendor_Company_ID ? "Updated Successfully" : "Added Successfully";
        body.state_ID = body.state?.state_ID;
        body.city_ID = body.city?.city_ID;
        delete body.state;
        delete body.city;

        const response = await Fetch("Vendor_Company_Mast", method, body, null, props.toast);
        if (response) {
            props.hideDialog();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.setReload(!props.reload);
        }
        setLoading(false);
    }

    const onHide = () => {
        props.hideDialog();
        reset(EmptyVendorCompany);
    }

    function onSubmit(data: IVendorCompanyMast) {
        saveToDB(data);

    }

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {

            if (name === "disable_Share_PV") {
                if (value.disable_Share_PV === true) setIsDisablePV(true);
                else setIsDisablePV(false);
            }
        });
        return () => subscription.unsubscribe();
    }, [watch]);



    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Client Company" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">

                <JVInput column={3} required label="Company Name" control={control} name="vendor_Company_Name" error={errors.vendor_Company_Name?.message} />
                <JVInput column={3} label="FID#" control={control} name="vendor_Company_FidNo" error={errors.vendor_Company_FidNo?.message} />
                <JVInputMask column={3} mask="(999) 999-9999" required label="Phone No" control={control} name="vendor_Company_Phone" error={errors.vendor_Company_Phone?.message} />
                <JVInputMask column={3} mask="(999) 999-9999" label="Alternate Phone No" control={control} name="vendor_Company_Phone1" error={errors.vendor_Company_Phone1?.message} />
                <JVInput column={3} label="Fax No." control={control} name="vendor_Company_FaxNo" error={errors.vendor_Company_FaxNo?.message} />
                <JVDropdown column={3} required label="Company Type" control={control} name="vendor_Type" error={errors.vendor_Type?.message} options={vendorTypes} optionLabel="vendor_Type" optionValue="vendortypeid" placeholder="Select Vendor Type" />
                <JVInput column={3} required label="Street Address" control={control} name="street_Address" error={errors.street_Address?.message} />

                <JVDropdownInput column={3} required completeMethod={completeMethodStates} label="State" control={control} name="state" error={errors.state?.state_ID?.message} options={states} optionLabel="state_Name" placeholder="Search State" />
                <JVDropdownInput column={3} required completeMethod={completeMethodCities} label="City" control={control} name="city" error={errors.city?.city_ID?.message} options={cities} optionLabel="city_Name" placeholder="Search City" />
                {/* <JVDropdown column={3} label="Category" control={control} name="category" options={partnerCategory} optionLabel="status_Name" optionValue="id" placeholder="Select Category" /> */}

                <JVInput column={3} label="Major Technology" control={control} name="major_Technology" error={errors.major_Technology?.message} />
                <JVInput column={3} required label="Website Url(http://www.domainname.com)" control={control} name="website_URL" error={errors.website_URL?.message} />
                <div style={{ marginBottom: '20px', width: '100%' }}></div>
                {(_roles.includes(1) || _roles.includes(26)) && <JVCheckbox column={4} control={control} name="disable_Share_PV" label="Disable Share PV" />}

                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button loading={loading} style={{ width: '100px' }} label="SAVE" type="submit"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200		"></Button>
                </div>
            </form>
        </Dialog>
    );
}
